/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-underscore-dangle */
import PropTypes from 'prop-types';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import React, { useCallback } from 'react';
import { Formik, Form } from 'formik';
import { withFormikDevtools } from 'formik-devtools-extension';
import { useHistory } from 'react-router-dom';
import RoutingUtil from 'src/utils/RoutingUtil';
import { isProduction } from 'src/config/index';
import FormikCreateSearchClear from 'src/components/formik/FormikCreateSearchClear';
import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { usePrevious } from 'src/utils/ReactHooksUtil';
import { includeStamp } from 'src/utils/StampUtils';
import CompanyDropDown from 'src/business-components/CompanyDropDown';
import MastersDropDown from 'src/business-components/MastersDropDown';
import { MASTERS_TYPES } from '../masters-container/MastersConstants';
import { InsuranceSlabYupSchema } from './InsuranceSlabPropTypes';
import { insuranceSlabResetAction, insuranceSlabUpsertAction } from './actions/InsuranceSlabActions';
import { FUEL_TYPES_LIST, NCB_TYPE_LIST } from '../product-container/ProductConstants';
import FormikSelect from 'src/components/formik/FormikSelect';
import FormikInput from 'src/components/formik/FormikInput';

const Render = (props) => {
    // DEV TOOL
    if (!isProduction()) {
        withFormikDevtools(props);
    }

    const {
        values,
        // errors,
        // touched,
        isSubmitting,
        onSearch,
        onClear,
        resetForm,
    } = props;

    return (
        <div className="card">
            <div className="card-body">
                <h5 className="card-title">Insurance Slab Details</h5>
                <Form autoComplete="disabled">
                    <div className="form-row">
                        <div className="form-group col-md-2">
                            <label>Slab Code</label>
                            <FormikInput
                                disabled
                                placeholder="Auto Generated"
                                name="slabCode"
                                type="text"
                                className="form-control"
                            />
                        </div>
                        <div className="form-group col-md-3">
                            <label>Company</label>
                            <CompanyDropDown
                                name="companyId"
                                value={values?.companyId}
                            />
                        </div>
                        <div className="form-group col-md-3">
                            <label>RTO State</label>
                            <MastersDropDown
                                name="rtoZone"
                                value={values?.rtoZone || ''}
                                masterType={MASTERS_TYPES.RTO_ZONE}
                            />
                        </div>
                        <div className="form-group md-3">
                            <label>RTO Location</label>
                            <FormikInput
                                name="RTOLocation"
                                type="text"
                                className="form-control"
                            />
                        </div>
                        <div className="form-group col-md-3">
                            <label>Policy Type</label>
                            <MastersDropDown
                                name="policyType"
                                value={values?.policyType || ''}
                                masterType={MASTERS_TYPES.POLICY_TYPE}
                            />
                        </div>
                        <div className="form-group col-md-3">
                            <label>Fuel Type</label>
                            <FormikSelect
                                name="fuelType"
                                items={FUEL_TYPES_LIST}
                                className="form-control"
                            />
                        </div>
                        <div className="form-group col-md-3">
                            <label>NCB</label>
                            <FormikSelect
                                name="ncbValue"
                                items={NCB_TYPE_LIST}
                                className="form-control"
                            />
                        </div>
                        <div className="form-group col-md-3">
                            <label>Slab Rate</label>
                            <FormikInput
                                name="slabRate"
                                type="number"
                                className="form-control"
                            />
                        </div>
                        <div className="form-row">
                            <div className="form-group ml-1">
                                <label>Is Slab rate in Percentage?</label>
                                <FormikInput
                                    name="isSlabRatePercentage"
                                    type="checkbox"
                                    className="ml-3"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="text-center py-4 mt-3">
                        <FormikCreateSearchClear
                            isSubmitting={isSubmitting}
                            isUpdate={Boolean(values._id)}
                            onSearch={onSearch}
                            onClear={onClear}
                            resetForm={resetForm}
                            values={values}
                            submitScope="master.insurance_slab_manager.manage.submit"
                            searchScope="master.insurance_slab_manager.manage.search"
                        />
                    </div>
                </Form>

            </div>
        </div>
    );
};

Render.propTypes = {
    isSubmitting: PropTypes.bool.isRequired,
    onSearch: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    values: PropTypes.shape({
        slabCode: PropTypes.string,
    }).isRequired,
};

let setSubmitting = () => { };

const InsuranceSlabForm = () => {
    const history = useHistory();
    // REDUX
    const dispatch = useDispatch();
   
    const {
        currentRecord,
        upsertReqStatus,
    } = useSelector((state) => state.InsuranceSlabReducer, shallowEqual);
    // if current record changed or request status changed the enable submit
    usePrevious({
        currentRecord,
        upsertReqStatus,
    }, (prev) => {
        if (
            prev.currentRecord !== currentRecord
            || (upsertReqStatus && prev.upsertReqStatus !== upsertReqStatus && upsertReqStatus !== REQUEST_STATUS.PENDING)) {
            setSubmitting(false);
        }
    });

    const onSubmit = useCallback((
        values,
        formikUtils,
    ) => {
        ({ setSubmitting } = formikUtils);
        includeStamp(values);
        dispatch(insuranceSlabUpsertAction(values));
    }, [
        dispatch,
    ]);

    const onSearch = useCallback(({
        companyId,
        rtoZone,
        policyType,
        RTOLocation,
        fuelType,
        ncbValue,
        slabRate,
    }) => {
        
        history.push(RoutingUtil.insuranceSlabSearch({
            companyId,
            rtoZone,
            policyType,
            RTOLocation,
            fuelType,
            ncbValue,
            slabRate,
        }));
    }, [
        history,
    ]);

    const onClear = useCallback(() => {
        dispatch(insuranceSlabResetAction());
    }, [
        dispatch,
    ]);

    return (
        <Formik
            onSubmit={onSubmit}
            onClear={onClear}
            enableReinitialize
            initialValues={currentRecord}
            validationSchema={InsuranceSlabYupSchema}
            onSearch={onSearch}
        >
            {(formikProps) => (
                <Render
                    onClear={onClear}
                    onSearch={onSearch}
                    {...formikProps}
                />
            )}
        </Formik>
    );
};

export default InsuranceSlabForm;
